"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTagPerformanceResponse = void 0;
const getLastWeight = (data) => {
    let weight;
    if ('history' in data) {
        const [last] = Object.values(data.history).slice(-1);
        weight = last.weight;
    }
    else {
        weight = data.weight;
    }
    return weight;
};
const transformTagPerformanceResponse = (data) => {
    return Object.entries(data).reduce((acc, [key, value]) => {
        acc[key] = {
            ...value,
            weight: getLastWeight(value),
        };
        return acc;
    }, {});
};
exports.transformTagPerformanceResponse = transformTagPerformanceResponse;
//# sourceMappingURL=helpers.js.map